/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/api/axiosInstance.js";
import type { GeneratePromptResponseMutationRequest, GeneratePromptResponseMutationResponse, GeneratePromptResponse400, GeneratePromptResponse401, GeneratePromptResponse404, GeneratePromptResponse409, GeneratePromptResponse500 } from "../../types/GeneratePromptResponse.js";
import type { Client, RequestConfig, ResponseErrorConfig } from "@/api/axiosInstance.js";

function getGeneratePromptResponseUrl() {
  const res = { method: 'POST', url: `/api/prompt` as const }
  return res
}

/**
 * @description Generates a prompt response based on the provided prompt reward request. The API extracts output text contained within <output> tags for clarity, while full output is logged for debugging purposes.
 * @summary Generate Prompt Response
 * {@link /api/prompt}
 */
export async function generatePromptResponse(data: GeneratePromptResponseMutationRequest, config: Partial<RequestConfig<GeneratePromptResponseMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<GeneratePromptResponseMutationResponse, ResponseErrorConfig<GeneratePromptResponse400 | GeneratePromptResponse401 | GeneratePromptResponse404 | GeneratePromptResponse409 | GeneratePromptResponse500>, GeneratePromptResponseMutationRequest>({ method : "POST", url : getGeneratePromptResponseUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}